// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"c85d47be96de13cccb29","883":"0e20e93afe5c813dd873"}[chunkId] + ".js";
};